import React from "react";
import { Header, HeaderCancel, HeaderTitle, HeaderAction } from "./styles";
import { MobilePanelHeaderProps } from "./types";

export const MobilePanelHeader: React.FC<MobilePanelHeaderProps> = ({
  title,
  actionLabel,
  isSubmitting,
  isActionDisabled = false,
  formId,
  onCancel,
}) => {
  const label = isSubmitting ? "Saving…" : actionLabel;

  return (
    <Header>
      <HeaderCancel type="button" onClick={onCancel} disabled={isSubmitting}>
        Cancel
      </HeaderCancel>
      <HeaderTitle>{title}</HeaderTitle>
      <HeaderAction
        type="submit"
        form={formId}
        disabled={isSubmitting || isActionDisabled}
      >
        {label}
      </HeaderAction>
    </Header>
  );
};
